import { Create, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { HttpError } from "@pankod/refine-core";

const schema = Yup.object({
  condition_action: Yup.string().required(),
  expired_at: Yup.date()
    .nullable()
    .optional()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  max_received: Yup.number()
    .nullable()
    .optional()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  name: Yup.string().optional(),
  tag_reward_id: Yup.number().optional(),
});

type Schema = Yup.InferType<typeof schema>;

export const TagActionCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm<Schema, HttpError, Schema>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("name")}
          error={!!errors.name}
          helperText={errors.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
        />
        <TextField
          {...register("condition_action")}
          required
          error={!!errors.condition_action}
          helperText={errors.condition_action?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Condition Action"
        />
        <TextField
          {...register("tag_reward_id")}
          error={!!errors.tag_reward_id}
          helperText={errors.tag_reward_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tag Reward Id"
        />
        <TextField
          {...register("max_received")}
          error={!!errors.max_received}
          helperText={errors.max_received?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Max Received"
        />
        <TextField
          {...register("expired_at")}
          error={!!(errors as any)?.expired_at}
          helperText={(errors as any)?.expired_at?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="datetime-local"
          label="Expired At (local)"
        />
      </Box>
    </Create>
  );
};
